import { useNavigate } from "react-router-dom";

const Header = () => {
  const navigate = useNavigate();
  const logout = () => {
    sessionStorage.clear();
    navigate("/", { replace: true });
  };
  return (
    <div className="header header-one hidden-print">
      <a className="mobile_btn" id="mobile_btn">
        <i className="fas fa-bars"></i>
      </a>
      <ul className="nav nav-tabs user-menu">
        <li className="nav-item dropdown">
          <div className="subscription-logout">
            <ul>
              <li className="">
                <a onClick={logout}>
                  <img
                    src={"/assets/img/power.png"}
                    alt="Logout"
                    style={{maxWidth:" 100%",height: "25px"}}
                  />
                </a>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  );
};

export default Header;
